import { createSelector } from 'reselect'

export const getName = (state, props) => {
  return state.kanbo.documentSources.documentSourcesById[props.id].name
}

export default createSelector(
  [
    getName
  ],
  (
    name
  ) => ({
    name
  })
)
